import { useState, useEffect } from "react";
import { WifiOff, Wifi } from "lucide-react";
import { toast } from "sonner";

interface OfflineDetectorProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export function OfflineDetector({ children, fallback }: OfflineDetectorProps) {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      if (wasOffline) {
        toast.success("You're back online!", {
          icon: <Wifi className="w-4 h-4" />,
          duration: 3000,
        });
      }
    };

    const handleOffline = () => {
      setIsOnline(false);
      setWasOffline(true);
      toast.warning("You're offline", {
        icon: <WifiOff className="w-4 h-4" />,
        description: "Some features may be limited",
        duration: 5000,
      });
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [wasOffline]);

  if (!isOnline && fallback) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
}
